/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifactpackready2Inputs */

const en_artifactpackready2 = /** @type {(inputs: Artifactpackready2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All facts captured — ready when payment opens.`)
};

const pt_artifactpackready2 = /** @type {(inputs: Artifactpackready2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos os factos recolhidos — pronto quando os pagamentos abrirem.`)
};

/**
* | output |
* | --- |
* | "All facts captured — ready when payment opens." |
*
* @param {Artifactpackready2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const artifactpackready2 = /** @type {((inputs?: Artifactpackready2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifactpackready2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_artifactpackready2(inputs)
	return pt_artifactpackready2(inputs)
});
export { artifactpackready2 as "artifactPackReady" }